/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class ChatRoomMemberInfo {
    memberCount;
    members;
}